export const BellasTardes = (props) => {
  return (
    <div id='bellastardes' className='container-fluid' style={{maxWidth: '100vw', overflowX: 'hidden'}}>
        <div className='row'>
            <div className='col col-md-5'>
                <h2>Bellas tardes<p className='btardes-ba'>en Bellas Artes</p></h2>
                <h4>Un paseo por el MNBA</h4>
                <p>Realizaremos un recorrido que nos ocupe desde los tiempos del <b>Renacimiento hasta las Vanguardias del Siglo XX</b>, haciendo las paradas correspondientes por el Barroco, el Romanticismo y el Impresionismo entre muchos otros momentos de la historia del arte.</p>
                <p><a href="mailto:historias.de.artes@gmail.com?Subject=Interesad@%20BellasTardes" className='fw-bolder'>Escribime para más información</a></p>
            </div>
            <div className='col col-md-7' style={{margin: '0', padding: '0'}}>
                <img src='img/bellastardes.jpg' className='img-responsive' alt='bellastardes'/>
            </div>
        </div>
    </div>
  );
};